import type { FC, Dispatch, SetStateAction } from "react";
import { useLocale } from "hooks";
import clsx from "clsx";
import type { Props as SelectProps } from "react-select";
import TabSelect from "./TabSelect";

interface IProps {
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  goTab: (key: string) => Promise<void>;
  layout: "primary" | "secondary";
  tabOptions?: SelectProps["options"];
  tabs: any[];
  mappedTabs: any;
}

const NewsTabs: FC<IProps> = ({
  layout = "primary",
  activeTab,
  setActiveTab,
  goTab,
  tabOptions,
  tabs,
  mappedTabs,
}) => {
  const { locale } = useLocale();

  return layout === "secondary" ? (
    <div className="tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-1 md:tw-border-b-0 tw-border-b-[#344456]/5 tw-col-span-5 md:tw-col-span-1">
      <TabSelect
        activeTab={activeTab}
        options={tabOptions}
        setActiveTab={setActiveTab}
        goTab={goTab}
        layout={layout}
      />
    </div>
  ) : (
    <div className="tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-1 md:tw-border-b-0 tw-border-b-[#344456]/5">
      {Object.entries(mappedTabs[locale] || {}).map(([key, label]) => (
        <button
          key={key}
          type="button"
          onClick={() => goTab(key)}
          className={clsx(
            "tw-cursor-pointer tw-text-[#344456] tw-text-[12px] md:tw-text-base xxxl:tw-text-[21.33px] tw-font-bold tw-px-1 md:tw-px-4 tw-mx-2 md:tw-mx-3 tw-py-2.5 tw-bg-zero tw-border-0 tw-border-solid tw-border-b-4",
            {
              "tw-border-zero hover:tw-text-[#007FAC]": activeTab !== key,
              "tw-border-[#007FAC]": activeTab === key,
            }
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default NewsTabs;
